var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tooltip',{attrs:{"placement":"right"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('div',{staticClass:"help-tooltip-content-wrap",domProps:{"innerHTML":_vm._s(_vm.content)}})]},proxy:true},{key:"default",fn:function(){return [_c('icon',{attrs:{"type":"question"}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }